import { getField, updateField } from "vuex-map-fields";

export default {
  namespaced: true,

  state: {
    taxes: [],
    currencies: []
  },

  getters: {
    getField
  },

  mutations: {
    updateField,

    updateTaxes (state, taxes) {
      state.taxes = taxes;
    },

    updateCurrencies (state, currencies) {
      state.currencies = currencies;
    }
  }
};
